import { useMemo } from "react";
import { createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { dropdownSaga } from "./saga";

export const initialState = {
  categories: { data: [], loading: false, error: null },
  languages: { data: [], loading: false, error: null },
  companies: { data: [], loading: false, error: null },
  cities: { data: [], loading: false, error: null },
  states: { data: [], loading: false, error: null },
  primaryCategories: { data: [], loading: false, error: null },
  subCategories: { data: [], loading: false, error: null },
  talentAgencyManagers: { data: [], loading: false, error: null },
  creatorPlans: { data: [], loading: false, error: null }
};

export const DropdownSlice = createSlice({
  name: "dropdown",
  initialState,
  reducers: {
    getCategoriesRequest(state) {
      state.categories.loading = true;
      state.categories.error = null;
    },
    getCategoriesSuccess(state, action) {
      state.categories.loading = false;
      state.categories.data = action.payload;
    },
    getCategoriesFailure(state, action) {
      state.categories.loading = false;
      state.categories.error = action.payload;
    },

    getLanguagesRequest(state) {
      state.languages.loading = true;
      state.languages.error = null;
    },
    getLanguagesSuccess(state, action) {
      state.languages.loading = false;
      state.languages.data = action.payload;
    },
    getLanguagesFailure(state, action) {
      state.languages.loading = false;
      state.languages.error = action.payload;
    },

    getCompaniesRequest(state) {
      state.companies.loading = true;
      state.companies.error = null;
    },
    getCompaniesSuccess(state, action) {
      state.companies.loading = false;
      state.companies.data = action.payload;
    },
    getCompaniesFailure(state, action) {
      state.companies.loading = false;
      state.companies.error = action.payload;
    },

    getCitiesRequest(state) {
      state.cities.loading = true;
      state.cities.error = null;
    },
    getCitiesSuccess(state, action) {
      state.cities.loading = false;
      state.cities.data = action.payload;
    },
    getCitiesFailure(state, action) {
      state.cities.loading = false;
      state.cities.error = action.payload;
    },

    getStatesRequest(state) {
      state.states.loading = true;
      state.states.error = null;
    },
    getStatesSuccess(state, action) {
      state.states.loading = false;
      state.states.data = action.payload;
    },
    getStatesFailure(state, action) {
      state.states.loading = false;
      state.states.error = action.payload;
    },

    getPrimaryCategoriesRequest(state) {
      state.primaryCategories.loading = true;
      state.primaryCategories.error = null;
    },
    getPrimaryCategoriesSuccess(state, action) {
      state.primaryCategories.loading = false;
      state.primaryCategories.data = action.payload;
    },
    getPrimaryCategoriesFailure(state, action) {
      state.primaryCategories.loading = false;
      state.primaryCategories.error = action.payload;
    },

    getSubCategoriesRequest(state) {
      state.subCategories.loading = true;
      state.subCategories.error = null;
    },
    getSubCategoriesSuccess: (state, action) => {
      const existing = state.subCategories.data || [];
      const incoming = action.payload || [];

      // Merge without duplicates
      const merged = [
        ...existing.filter((e) => !incoming.some((i) => i.id === e.id)),
        ...incoming
      ];

      state.subCategories.data = merged;
      state.subCategories.loading = false;
    },
    getSubCategoriesFailure(state, action) {
      state.subCategories.loading = false;
      state.subCategories.error = action.payload;
    },

    getTalentAgencyManagersRequest(state) {
      state.talentAgencyManagers.loading = true;
      state.talentAgencyManagers.error = null;
    },
    getTalentAgencyManagersSuccess(state, action) {
      state.talentAgencyManagers.loading = false;
      state.talentAgencyManagers.data = action.payload;
    },
    getTalentAgencyManagersFailure(state, action) {
      state.talentAgencyManagers.loading = false;
      state.talentAgencyManagers.error = action.payload;
    },

    getCreatorPlansRequest(state) {
      state.creatorPlans.loading = true;
      state.creatorPlans.error = null;
    },
    getCreatorPlansSuccess(state, action) {
      state.creatorPlans.loading = false;
      state.creatorPlans.data = action.payload;
    },
    getCreatorPlansFailure(state, action) {
      state.creatorPlans.loading = false;
      state.creatorPlans.error = action.payload;
    }
  }
});

export const useDropdownSlice = () => {
  useInjectReducer(DropdownSlice.name, DropdownSlice.reducer);
  useInjectSaga(DropdownSlice.name, dropdownSaga);
  const actions = useMemo(() => DropdownSlice.actions, []);
  return { actions };
};

export const { actions: dropdownActions } = DropdownSlice;
export default DropdownSlice.reducer;
